/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule isEventHandled
 * @format
 * 
 */
'use strict';
/**
 * Utility method for determining whether or not the value returned
 * from a handler indicates that it was handled.
 */

function isEventHandled(value) {
  return value === 'handled' || value === true;
}

module.exports = isEventHandled;